// extracted by mini-css-extract-plugin
export default {"root":"BaseLayout-module_root__lZmVL","header":"BaseLayout-module_header__s1kkA","main":"BaseLayout-module_main__AKrXN"};